export const discount_routes = [
  // {
  //   path: "/investments",
  //   component: () => import("../Main.vue"),
  //   name: "Ativos de Investimento"
  // }
];

export default {};
